module.exports = __webpack_public_path__ + "static/media/note-3.73489071.jpg";